var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'ホームの距離値が反映されない理由は？'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          ホーム画面に表示されている距離は歩数と歩幅によって計算した値です。「ウォーク/ラン」機能を利用して記録したデータのみがGPSウォーク／ランイベントの対象データとなります。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa46b77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help15.vue
// module id = amJB
// module chunks = 0